import { ofetch, FetchError } from 'ofetch';
import { ApiClientError } from '../api/errors';
import { createDebugLogger } from '../utils/debug';
import { attachBearer } from '../auth/attachBearer';

const dlog = createDebugLogger('pulse');

/**
 * Pulse-API-Client. Immer über den BFF-Proxy `/proxy/pulse/...` — Frontend
 * sieht das GATEWAY_SHARED_SECRET nie. Pulse akzeptiert denselben
 * CORE-Bearer wie Orbit selbst (kein M2M-Modus nötig), deshalb reicht
 * reines Pass-through analog `nexusBearerFetch`.
 */

const raw = ofetch.create({
  baseURL: '/proxy/pulse',
  onRequest(ctx) { attachBearer(ctx); dlog('→', ctx.request); }, // #501
  onResponse({ request, response }) { dlog('←', request, response.status); },
});

export async function pulseFetch(path, opts = {}) {
  try {
    return await raw(path, opts);
  } catch (err) {
    if (err instanceof FetchError) {
      const data = err.data;
      throw new ApiClientError({
        code: data?.error?.code ?? 'pulse_request_failed',
        message: data?.error?.message ?? err.message,
        status: err.response?.status ?? 0,
        details: data?.error?.details,
      });
    }
    throw err;
  }
}

export function isPulseProxyEnabled() {
  if (typeof window === 'undefined') return false;
  return window.__ORBIT_CONFIG__?.pulseProxyEnabled === true;
}
